import { render, staticRenderFns } from "./AuthorityTable.vue?vue&type=template&id=69a4b738&"
import script from "./AuthorityTable.vue?vue&type=script&lang=ts&"
export * from "./AuthorityTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports